import { render } from "./BillUser.vue?vue&type=template&id=7538a579&ts=true"
import script from "./scripts/bill-user.ts?vue&type=script&lang=ts"
export * from "./scripts/bill-user.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__